(function () {
  'use strict';

  angular.module('ringbaPortal').directive('stPersist', stPersist);

  // this directive will save the tableState as used by smart table
  // However, the tableState does not save the ordering of columns
  // For saving that, we are using lrDragNDrop's dropSuccess method
  // inside the controller for which we are implementing drag and drop
  // we can use this directive to store table states of different tables
  // under user settings. This is controlled by the st-persist attribute
  // in the view whose value is translated to nameSpace. For example,
  // in campaigns table, we set st-persist="campaigns". Now the tableState
  // for that table will be stored under userSettings.campaigns.tableState
  function stPersist (_, userSettingsService) {
    return {
      require: '^stTable',
      restrict: 'A',
      link: function (scope, element, attr, ctrl) {
        const nameSpace = attr.stPersist;
        //save the table state every time it changes
        scope.$watch(function () {
          return ctrl.tableState();
        }, function (newValue, oldValue) {
          if (newValue !== oldValue) {
            userSettingsService.getUserSettings()
              .then(function (userSettings){
                if (userSettings) {
                  if (!userSettings[nameSpace]) {
                    userSettings[nameSpace] = {};
                  }
                  // Updated to only save table sort
                  // Search and Pagination shouldn't be saved to the settings
                  userSettings[nameSpace].tableState = userSettings[nameSpace].tableState || {};
                  userSettings[nameSpace].tableState.sort = newValue.sort;

                  userSettingsService.saveUserSettings(userSettings);
                }
              });
          }
        }, true);

        //fetch the table state when the directive is loaded
        userSettingsService.getUserSettings()
          .then(function (userSettings){
            const tableState = ctrl.tableState();
            if (userSettings && userSettings[nameSpace] && userSettings[nameSpace].tableState) {
              const savedState = userSettings[nameSpace].tableState;
              // Currently not using saved pagination values
              // Remove this line when we start saving user pagination preference
              delete savedState.pagination;
              // We shouldn't save the search options back to the uiSettings
              delete savedState.search;

              angular.extend(tableState, savedState);
              if ((!tableState.sort || _.isEmpty(tableState.sort)) && attr.defaultSortColumn) {
                _setDefaultSort(tableState, attr.defaultSortColumn, attr.defaultSortDirection);
              }
              ctrl.pipe();
            } else {
              angular.extend(tableState);
              _setDefaultSort(tableState, attr.defaultSortColumn, attr.defaultSortDirection);
              ctrl.pipe();
            }
          });

        function _setDefaultSort(tableState, sortColumn, sortDirection) {
          if (tableState) {
            tableState.sort = {
              predicate: sortColumn,
              reverse: (sortDirection && sortDirection.toLowerCase() === 'desc') ? true : false
            };
          }
        }
      }
    };
  }
}());
